import { render, staticRenderFns } from "./QaApproveFormulationPopUp.vue?vue&type=template&id=4a9fa962&scoped=true&"
import script from "./QaApproveFormulationPopUp.vue?vue&type=script&lang=js&"
export * from "./QaApproveFormulationPopUp.vue?vue&type=script&lang=js&"
import style0 from "./QaApproveFormulationPopUp.vue?vue&type=style&index=0&id=4a9fa962&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9fa962",
  null
  
)

export default component.exports